import angular from "angular";
import homeModule from '../home/home';
import FooterCoreModule from '../footer-core/footer-core';
import AuthModule from '../auth/auth';
// import headerModulesModule from '../header-modules/header-modules';
// import knowUsModule from './know-us/know-us';
// import contactModule from './contact/contact';
// import accountModule from './account/account';
// import registerModule from './register/register';
// import usersModule from './users/users';
import loginModule from '../login/login';
import HeaderCoreModule from '../header-core/header-core';


let HomeAplicacionModule = angular.module('homeAplication',[
   homeModule.name,
   FooterCoreModule.name,
   AuthModule.name,
   // headerModulesModule.name,
   loginModule.name,
   HeaderCoreModule.name
   // knowUsModule.name
]);

export default HomeAplicacionModule;


// WEBPACK FOOTER //
// ./www/components/home-aplication/home-aplication.js